(() => {
  if (window.__configuratorBundleRemoveBound) return;
  window.__configuratorBundleRemoveBound = true;

  const hydrateBundleSpecifications = () => {
    document
      .querySelectorAll(".configurator-bundle__specifications")
      .forEach((container) => {
        // Idempotency guard: the cart drawer / cart page re-render fresh
        // (empty) markup after add-to-cart, so hydration must be able to run
        // again on the new nodes without duplicating rows on already-done ones.
        if (container.dataset.specsHydrated === "true") return;

        const list = container.querySelector("ul");
        const raw = container.dataset.bundleSpecifications;
        if (!list || !raw) {
          container.remove();
          return;
        }

        let specs;
        try {
          specs = JSON.parse(raw);
        } catch (error) {
          container.remove();
          return;
        }

        if (!Array.isArray(specs) || !specs.length) {
          container.remove();
          return;
        }

        const validSpecs = specs
          .map((spec) => {
            if (!spec || (!spec.label && !spec.value)) return null;
            return {
              label: `${spec.label || ""}`.trim(),
              value: `${spec.value || ""}`.trim(),
            };
          })
          .filter(Boolean);

        if (!validSpecs.length) {
          container.remove();
          return;
        }

        container.dataset.specsHydrated = "true";

        validSpecs.forEach((spec) => {
          const row = document.createElement("li");
          const label = document.createElement("span");
          const value = document.createElement("span");
          label.textContent = spec.label;
          value.textContent = spec.value;
          row.appendChild(label);
          row.appendChild(value);
          list.appendChild(row);
        });
      });
  };

  // The cart drawer (<cart-drawer>) and cart page (<cart-items>) replace their
  // inner HTML when the cart changes (add-to-cart, quantity update, etc.).
  // Publish/render ordering varies per path, so instead of relying on the
  // cartUpdate pub/sub event we observe the containers and re-hydrate whenever
  // fresh bundle markup is injected. Hydration is idempotent (see guard above).
  const observeCartRerenders = () => {
    const observer = new MutationObserver(() => hydrateBundleSpecifications());
    const targets = document.querySelectorAll("cart-drawer, cart-items, cart-notification");

    if (targets.length) {
      targets.forEach((target) =>
        observer.observe(target, { childList: true, subtree: true })
      );
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  hydrateBundleSpecifications();
  observeCartRerenders();

  document.addEventListener("click", async (event) => {
    const button = event.target.closest(".configurator-bundle-remove");
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const keys = (button.dataset.lineKeys || "")
      .split("||")
      .map((value) => value.trim())
      .filter(Boolean);

    if (!keys.length) return;

    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    button.setAttribute("disabled", "disabled");

    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      window.location.reload();
    } catch (error) {
      button.removeAttribute("disabled");
      console.error("Failed to remove configurator bundle", error);
    }
  });
})();
